import { WarningCircleIcon, XIcon } from '@phosphor-icons/react';

import { ICON_WEIGHT } from '@/components/icon';
import { Button } from '@/components/ui/button';

import { useOpenedFileNotice } from './open-files';

/** The result of opening an `.fdv` from outside the app. See `open-files.ts`. */
export function OpenedFileNotice() {
  const { message, tone } = useOpenedFileNotice();
  if (message === null) {
    return null;
  }
  return (
    <aside
      role="status"
      className="border-border bg-surface rounded-container mb-6 flex items-start gap-2 border px-4 py-3 text-sm print:hidden"
    >
      {tone === 'error' ? (
        <WarningCircleIcon
          aria-hidden="true"
          weight={ICON_WEIGHT}
          className="text-danger mt-0.5 size-4 shrink-0"
        />
      ) : null}
      <span className="min-w-0 flex-1 break-words">{message}</span>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Dismiss"
        onClick={() => {
          useOpenedFileNotice.setState({ message: null });
        }}
      >
        <XIcon aria-hidden="true" weight={ICON_WEIGHT} className="size-4" />
      </Button>
    </aside>
  );
}
